export default {
  functionKey: "CONVERSION DIACRITIQUES",
  title: "CONVERSION DIACRITIQUES",
  group: "Texte",
  origin: [],
  target: [],
  description: "Convertit les caractères diacritiques en caractères non-diacritiques",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const code = `${destination} = ${origin}.normalize('NFD').replace(/[\\u0300-\\u036f]/g, '');`;
    return { displayCode: code, safeCode: code };
  }
}
